import { FC, useEffect, useRef, useState } from 'react';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import Package from '../types/package.type';

type PackageWeightCustomColumnProps = {
  initialValue: Package['package_weight'];
  onChange: (value: Package['package_weight']) => void;
};

const PackageWeightCustomColumn: FC<PackageWeightCustomColumnProps> = ({
  initialValue,
  onChange,
}) => {
  const onChangeRef = useRef(onChange);

  const [packageWeight, setPackageWeight] = useState<Package['package_weight']>(
    {
      unit: initialValue.unit || 'lb',
      value: initialValue.value || 0,
    },
  );

  useEffect(() => onChangeRef.current(packageWeight), [packageWeight]);

  return (
    <Stack direction='row' spacing={1}>
      <TextField
        label=''
        placeholder='Weight'
        variant='standard'
        value={packageWeight.value}
        inputProps={{ type: 'number' }}
        onChange={(e) =>
          setPackageWeight((prev) => ({
            ...prev,
            value: parseFloat(e.target.value),
          }))
        }
        onKeyDown={(e) => e.stopPropagation()}
      />

      <Select
        variant='standard'
        value={packageWeight.unit}
        onChange={(e) =>
          setPackageWeight((prev) => ({
            ...prev,
            unit: e.target.value as Package['package_weight']['unit'],
          }))
        }
      >
        <MenuItem value='lb'>lb</MenuItem>
        <MenuItem value='kg'>kg</MenuItem>
        <MenuItem value='g'>g</MenuItem>
        <MenuItem value='oz'>oz</MenuItem>
      </Select>
    </Stack>
  );
};

export default PackageWeightCustomColumn;
